import { IoIosColorPalette } from "react-icons/io";
import { DiResponsive } from "react-icons/di";
import { GiDistraction } from "react-icons/gi";

const projectsData = [
  {
    id: 'serratti',
    name: "Serratti Importaciones",
    logo: "https://firebasestorage.googleapis.com/v0/b/eienweb.firebasestorage.app/o/clients-logo%2Flogo_serratti.png?alt=media&token=8ac4d756-616e-400a-9457-2b9053cf6070",
    description: "Sitio web moderno y funcional, destacando sus marcas y facilitando el contacto.",
    website: "https://gruposerratti.com",
    preview: "https://firebasestorage.googleapis.com/v0/b/eienweb.firebasestorage.app/o/client-images%2Fserratti%2Fpreview_serratti.png?alt=media&token=35ac0e24-1dea-4433-8c8f-f1803bee052c",
    introduction: "Serratti Importaciones S.A. es una empresa paraguaya con más de 30 años de experiencia en la importación, distribución y comercialización de productos perecederos y no perecederos. Su objetivo principal era renovar su presencia en línea para reflejar su trayectoria y diversidad de productos, mejorando la experiencia del usuario y facilitando el acceso a la información clave.",
    // New fields
    modeloAplicado: "Financiado",
    stack: ["React", "Tailwind CSS", "Node.js", "Firebase", "Sanity CMS"],
    timeline: "8 semanas",
    impacto: [
      { metric: "+65%", description: "Tiempo en página vs. sitio anterior" },
      { metric: "-40%", description: "Bounce rate" },
    ],
    equipo: ["1 Dev Frontend", "1 UX Designer"],
    entregables: ["Diseño UI/UX", "Desarrollo Frontend", "Integración CMS", "SEO básico", "Deploy"],
    details: [
      {
        title: "Encabezado Principal",
        content: "Usamos una imagen de contenedores con un lema claro que refuerza la experiencia de la empresa en logística y comercio, conectando con su público objetivo.",
      },
      {
        title: "Sección '¿Por qué elegirnos?'",
        content: "Incluimos una enumeración y descripciones breves para ilustrar sus servicios clave, permitiendo a los usuarios entender rápidamente su propuesta de valor. Optamos por un diseño semicircular en esta sección porque dirige visualmente la atención hacia los servicios principales, manteniendo al usuario enfocado y comprometido. Este enfoque también crea una sensación de continuidad visual que refuerza la idea de un flujo eficiente en las operaciones de la empresa.",
        image: "https://firebasestorage.googleapis.com/v0/b/eienweb.firebasestorage.app/o/client-images%2Fserratti%2Fserratti_why_choose_us.png?alt=media&token=036b35f1-c835-453f-939a-487e988e8c33",
      },
      {
        title: "Presentación de Marcas",
        content: "Creamos una sección dedicada a destacar sus marcas representadas, como TIVA, con un diseño que combina elementos visuales y funcionales. Incluimos enlaces directos a catálogos actualizados para facilitar el acceso a información detallada de los productos. Optamos por un diseño limpio y acordeón para organizar la información clave ('Variedad y Calidad', 'Accesibilidad', 'Packaging Innovador'), lo que permite al usuario explorar cada aspecto de manera intuitiva. Esto mejora la navegación al reducir el desorden visual y asegura que los usuarios encuentren rápidamente lo que buscan, aumentando su tiempo de permanencia en la página.",
        image: "https://firebasestorage.googleapis.com/v0/b/eienweb.firebasestorage.app/o/client-images%2Fserratti%2Fserratti_brands.png?alt=media&token=620e578f-1b00-4978-8fcd-ee28c2418607",
      },
    ],
    designHighlights: [
      {
        icon: <IoIosColorPalette size={50} color="#CD5C5C" />,
        title: "Colores Corporativos",
        description: "Optamos por colores corporativos para reforzar la identidad de marca y destacar los valores de calidad y compromiso de Serratti.",
      },
      {
        icon: <DiResponsive size={50} color="#a6ca24" />,
        title: "Diseño Responsivo",
        description: "Aseguramos que el sitio web funcione perfectamente en cualquier dispositivo, proporcionando accesibilidad y consistencia en la experiencia del usuario.",
      },
      {
        icon: <GiDistraction size={50} color="#247ad0" />,
        title: "Estructura Clara",
        description: "Creamos una navegación simple y bien organizada para que los usuarios encuentren rápidamente lo que necesitan sin distracciones innecesarias.",
      },
    ],
  },
  {
    id: 'utility-helpnet',
    name: "Utility HelpNet, Inc.",
    logo: "https://firebasestorage.googleapis.com/v0/b/eienweb.firebasestorage.app/o/clients-logo%2Fuhnlogo.gif?alt=media&token=3316ae02-892f-4369-92dd-0d673f6ce890",
    description: "Transformación digital completa de operaciones comerciales.",
    website: "https://example.com",
    preview: "https://firebasestorage.googleapis.com/v0/b/eienweb.firebasestorage.app/o/client-images%2Futility-helpnet%2Fpreview_utilityHelpnet.png?alt=media&token=b35a6f19-7cfb-4ef1-bc59-20f87c6ef403",
    introduction: "Utility HelpNet, Inc. es una empresa de ingeniería que se especializa en diseño de servicios públicos, sistemas SCADA y soluciones de generación eléctrica. Con sede en Wichita, Kansas, el objetivo principal era desarrollar una plataforma moderna que reflejara su experiencia técnica, destacando sus servicios y proyectos exitosos de más de 20 años.",
    // New fields
    modeloAplicado: "Revenue Share",
    stack: ["React", "Next.js", "Tailwind CSS", "PostgreSQL", "AWS"],
    timeline: "12 semanas",
    impacto: [
      { metric: "+120%", description: "Leads generados por mes" },
      { metric: "35+", description: "Años de experiencia destacados" },
    ],
    equipo: ["1 Dev Full Stack", "1 UX Designer", "1 Project Manager"],
    entregables: ["Arquitectura técnica", "Diseño UI/UX", "Desarrollo Full Stack", "CRM Integration", "Analytics", "Deploy en AWS"],
    details: [
      {
        title: "Encabezado Impactante",
        content: "Creamos un encabezado visualmente atractivo utilizando una imagen de torres eléctricas al amanecer. Esto conecta directamente con la industria eléctrica y transmite estabilidad y experiencia. Además, colocamos un llamado a la acción destacado ('Request Consultation') en la esquina superior derecha para fomentar la interacción inmediata.",
        image: "https://firebasestorage.googleapis.com/v0/b/eienweb.firebasestorage.app/o/client-images%2Futility-helpnet%2Futility_header.png?alt=media&token=53a553db-3ab3-498f-84d2-45443ada226e",
      },
      {
        title: "Sección de Servicios",
        content: "Diseñamos esta sección para organizar los servicios principales de manera clara y visualmente atractiva. Cada servicio está numerado, lo que ayuda al usuario a explorar de forma secuencial y comprender la estructura del negocio. Este enfoque mejora la navegación y permite que los usuarios identifiquen rápidamente los servicios que necesitan.",
        image: "https://firebasestorage.googleapis.com/v0/b/eienweb.firebasestorage.app/o/client-images%2Futility-helpnet%2Futility_services.png?alt=media&token=27e07e64-c28c-44af-bea6-55a687e16387",
      },
      {
        title: "Éxitos Clave",
        content: "Enfatizamos los logros clave de Utility HelpNet con una sección dedicada al éxito de sus proyectos. Esto incluye datos destacados como '20 clientes' y '35 años de experiencia'. Optamos por un diseño minimalista con números grandes para captar la atención del usuario de forma instantánea.",
        image: "https://firebasestorage.googleapis.com/v0/b/eienweb.firebasestorage.app/o/client-images%2Futility-helpnet%2Futility_success.png?alt=media&token=fbdc7b0b-de3b-4d42-bc86-596191376e5f",
      },
    ],
    designHighlights: [
      {
        icon: <IoIosColorPalette size={50} color="#FF4500" />,
        title: "Estilo Profesional",
        description: "Seleccionamos una paleta de colores sobria y profesional que comunica experiencia técnica y estabilidad en la industria eléctrica.",
      },
      {
        icon: <DiResponsive size={50} color="#32CD32" />,
        title: "Interactividad",
        description: "Incluimos elementos interactivos, como botones de acción prominentes, para captar la atención de los usuarios y facilitar la conversión.",
      },
      {
        icon: <GiDistraction size={50} color="#1E90FF" />,
        title: "Centrado en Datos",
        description: "Destacamos estadísticas clave como '20 clientes' y '35 años de experiencia' para reforzar la confianza y credibilidad de los usuarios.",
      },
    ],
  },
  {
    id: 'gorostiaga-cazenave',
    name: "Gorostiaga-Cazenave & Asociados",
    logo: "https://firebasestorage.googleapis.com/v0/b/eienweb.firebasestorage.app/o/clients-logo%2Flogo_ejGC.webp?alt=media&token=4885c7b3-db4b-4dbb-b2c0-8925e4aa2009",
    description: "Desarrollo de plataforma personalizada de comercio electrónico.",
    website: "https://gorostiaga-cazenave.netlify.app/",
    preview: "https://firebasestorage.googleapis.com/v0/b/eienweb.firebasestorage.app/o/client-images%2Festudio-g-c%2Fpreview_EJGC.png?alt=media&token=e735040f-0122-4c27-a92c-15f6923c89ca",
    introduction: "Gorostiaga-Cazenave & Asociados es uno de los estudios jurídicos más prestigiosos de Argentina, con más de 25 años de experiencia. El objetivo principal era construir un sitio que reflejara su compromiso con la excelencia y la atención personalizada, destacando sus áreas de práctica y el equipo profesional.",
    // New fields
    modeloAplicado: "Financiado",
    stack: ["React", "Tailwind CSS", "Netlify", "EmailJS"],
    timeline: "6 semanas",
    impacto: [
      { metric: "+80%", description: "Consultas vía WhatsApp" },
      { metric: "4.8/5", description: "Satisfacción del cliente" },
    ],
    equipo: ["1 Dev Frontend", "1 UX Designer"],
    entregables: ["Diseño UI/UX", "Desarrollo Frontend", "Integración WhatsApp", "SEO", "Deploy"],
    details: [
      {
        title: "Encabezado Principal",
        content: "Usamos una imagen icónica de la Justicia para transmitir profesionalismo y confianza. Además, se añadió un botón destacado de WhatsApp para facilitar el contacto directo con los usuarios.",
        image: "https://firebasestorage.googleapis.com/v0/b/eienweb.firebasestorage.app/o/client-images%2Festudio-g-c%2Fgorostiaga_header.png?alt=media&token=c97c6666-9dc4-49c1-9cdf-f3cbaca9765a",
      },
      {
        title: "Áreas de Práctica",
        content: "Organizamos las áreas de práctica en tarjetas visuales con iconos representativos, permitiendo una navegación clara y rápida. Esto facilita que los clientes identifiquen el servicio que necesitan sin esfuerzo.",
        image: "https://firebasestorage.googleapis.com/v0/b/eienweb.firebasestorage.app/o/client-images%2Festudio-g-c%2Fgorostiaga_areas.png?alt=media&token=87473182-1df9-467a-bc15-e3cb48be4bfc",
      },
      {
        title: "Equipo Profesional",
        content: "Mostramos a los socios principales del estudio en un formato de tarjetas. Esto humaniza la marca y genera confianza al presentar el talento detrás de los servicios legales.",
        image: "https://firebasestorage.googleapis.com/v0/b/eienweb.firebasestorage.app/o/client-images%2Festudio-g-c%2Fgorostiaga_team.png?alt=media&token=f7148439-cf27-4bf1-8031-8a5fb27751cb",
      },
      {
        title: "Sección de Artículos",
        content: "Incluimos una sección de artículos legales con un diseño limpio para educar a los clientes potenciales y reforzar la autoridad del estudio en temas legales relevantes.",
        image: "https://firebasestorage.googleapis.com/v0/b/eienweb.firebasestorage.app/o/client-images%2Festudio-g-c%2Fgorostiaga_articles.png?alt=media&token=8726cf16-9c03-4a80-962e-bf92ce2e97ff",
      },
    ],
    designHighlights: [
      {
        icon: <IoIosColorPalette size={50} color="#2C3E50" />,
        title: "Colores Sobrios",
        description: "Utilizamos una paleta de colores azul y blanco para transmitir confianza, profesionalismo y serenidad, alineados con la naturaleza del estudio jurídico.",
      },
      {
        icon: <DiResponsive size={50} color="#16A085" />,
        title: "Interfaz Amigable",
        description: "Diseñamos una interfaz accesible y responsiva para que los usuarios encuentren información clave fácilmente, desde cualquier dispositivo.",
      },
      {
        icon: <GiDistraction size={50} color="#E74C3C" />,
        title: "Llamadas a la Acción",
        description: "Integramos botones visibles y claros para contactar al estudio mediante WhatsApp o correo electrónico, priorizando la conversión y la interacción.",
      },
    ],
  },
];

export default projectsData;
